// extracted by mini-css-extract-plugin
export default {"noStyle":"ClickLink_noStyle__wA5Uw"};